import { render, staticRenderFns } from "./QuestionBankList.vue?vue&type=template&id=2f4e24a5&scoped=true&"
import script from "./QuestionBankList.vue?vue&type=script&lang=js&"
export * from "./QuestionBankList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankList.vue?vue&type=style&index=0&id=2f4e24a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e24a5",
  null
  
)

export default component.exports